<template>
  <form class="c-form-update-card" @submit.prevent="onSubmit">
    <Form
      :processing="processing"
      ref="form"
      :schema="schema"
      v-model="form"
      buttonText="Unsubscribe"
      @status="saveStatus"
      :errors="errors"
    ></Form>
  </form>
</template>

<script>
import Form from "./index.vue";

const schema = {
  cardNumber: {
    component: "InputText",
    label: "Card Number",
    validations: {
      required: {
        params: null,
      },
    },
  },
  dateOfExpiry: {
    component: "InputText",
    label: "Card date of expiry",
    validations: {
      required: {
        params: null,
      },
    },
  },
  cvc: {
    component: "InputText",
    label: "CVC code",
    validations: {
      required: {
        params: null,
      },
    },
  },
};
export default {
  components: {
    Form,
  },

  data: function () {
    return {
      schema: schema,
      processing: false,
      form: {
        seats: "",
      },
      errors: [],
      status: null,
    };
  },

  methods: {
    saveStatus: function (saveStatus) {
      this.status = saveStatus;
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (this.status.invalid) {
        return;
      }

      this.processing = true;

      let form = this.form;

      let res = null;

      await this.$store.dispatch("users/buy", {
        plan: "monthly-seat",
        quantity: parseInt(form.seats),
      });
      return;

      try {
        res = await this.$store.dispatch("users/updatePassword", form);
      } catch (err) {
        console.log(err);
        if (err.length === 0) {
          err.push({
            message: "Something went wrong, please send another reset password request.",
          });
        }
        this.errors = err;
        this.processing = false;
        return;
      }

      await this.$store.dispatch("afterLogin");

      await this.$store.dispatch("message/onPasswordReset");

      this.$emit("onSubmit");

      this.processing = false;
    },
  },

  mounted: function () {},
};
</script>

<style></style>
